import { useCallback } from "react"

import {
  UseIdStringFilterProps,
  UseIdStringFilterRes,
} from "./types/useFilter.types"

export function useIdStringFilter<TValue extends { idString: string }>(
  props: UseIdStringFilterProps<TValue>
): UseIdStringFilterRes {
  const { useFilter, ...restProps } = props

  const idStringExtractor = useCallback(({ idString }: TValue) => idString, [])

  return useFilter({
    ...restProps,
    keyExtractor: idStringExtractor,
  })
}
